export enum ContractCreateStep {
  UPLOAD_CONTRACT,
  PROJECT_ADDRESS,
  YOUR_PARTY,
  OTHER_PARTIES,
  PAYMENTS,
  VARIATIONS,
  TERMS_MARGINS_DAMAGES,
  CONSTRUCTION_PERIOD,
  FINANCE,
  REVIEW,
}

export enum ContractReviewStep {
  START_REVIEW,
  PROJECT_ADDRESS,
  YOUR_PARTY,
  OTHER_PARTIES,
  PAYMENTS,
  VARIATIONS,
  TERMS_MARGINS_DAMAGES,
  CONSTRUCTION_PERIOD,
  FINANCE,
  SUMMARY,
}

export enum UiClaimStatus {
  UNCLAIMED = 'UNCLAIMED',
  CLAIMED_UNPAID = 'CLAIMED_UNPAID',
  PAID = 'PAID',
}
